import {
  Sprout, Store as StoreIcon, Shirt, Milk, Cookie, Hotel, Pill,
  Smartphone, Lightbulb, BookOpen, Landmark, Gem,
} from 'lucide-react';

export const CATEGORIES = [
  { id: 'kirana',      label: 'Kirana',       hi: 'किराना',     Icon: StoreIcon,   bg: '#FFF3E0', fg: '#8D3A0A' },
  { id: 'vegetables',  label: 'Vegetables',   hi: 'सब्ज़ी',      Icon: Sprout,      bg: '#E8F5E9', fg: '#1B5E20' },
  { id: 'medical',     label: 'Pharmacy',     hi: 'दवाई',       Icon: Pill,        bg: '#FFEBEE', fg: '#B71C1C' },
  { id: 'dairy',       label: 'Dairy',        hi: 'डेयरी',       Icon: Milk,        bg: '#E3F2FD', fg: '#0D47A1' },
  { id: 'bakery',      label: 'Bakery',       hi: 'बेकरी',       Icon: Cookie,      bg: '#FBE9E7', fg: '#8D3A0A' },
  { id: 'hotels',      label: 'Food & Tiffin',hi: 'खाना',       Icon: Hotel,       bg: '#FFF8E1', fg: '#8D6E00' },
  { id: 'cloth',       label: 'Cloth',        hi: 'कपड़ा',       Icon: Shirt,       bg: '#EDE7F6', fg: '#4527A0' },
  { id: 'fancy',       label: 'Fancy',        hi: 'फैंसी',       Icon: Gem,         bg: '#FFF8E1', fg: '#9A7B0A' },
  { id: 'electronics', label: 'Electronics',  hi: 'इलेक्ट्रॉनिक्स', Icon: Smartphone,  bg: '#E3F2FD', fg: '#0D47A1' },
  { id: 'electrical',  label: 'Electrical',   hi: 'बिजली सामान', Icon: Lightbulb,   bg: '#FFF8E1', fg: '#8D6E00' },
  { id: 'books',       label: 'Books',        hi: 'किताबें',     Icon: BookOpen,    bg: '#FFF3E0', fg: '#8D3A0A' },
  { id: 'artifacts',   label: 'Crafts',       hi: 'हस्तशिल्प',    Icon: Landmark,    bg: '#EFEBE9', fg: '#4E342E' },
];
